import { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { PaginationLayout } from "./PaginationLayout";

type Props = {
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  isTableDataLoading?: boolean;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pagination = ({
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  totalPages,
  onPageChange,
}: Props) => {
  const [activePages, setActivePages] = useState<any>([]);
  let firstIndex = (currentPage - 1) * rowsPerPage + 1;
  let lastIndex =
    currentPage * rowsPerPage +
    (totalPages === currentPage ? (totalData % rowsPerPage) - rowsPerPage : 0);

  useEffect(() => {
    if (totalPages === 1) {
      setActivePages([currentPage]);
    } else {
      setActivePages([currentPage, currentPage + 1]);
    }
  }, [totalPages]); // eslint-disable-line

  const handlePageChange = (page: number) => {
    if (!activePages.includes(page)) {
      if (page === totalPages) {
        setActivePages([page - 1, page]);
      } else {
        if (page < activePages[0]) {
          setActivePages([page, page + 1]);
        }
        if (page > activePages[1]) {
          setActivePages([page - 1, page]);
        }
      }
    }
    onPageChange(page);
  };

  return (
    <StyledPaginationLayout>
      <PaginationText>
        {firstIndex}-{lastIndex}
        {" of"} {totalData}
        {totalData === 1 ? " item" : " items"}
      </PaginationText>
      <PaginationLayout
        onPageChange={handlePageChange}
        isTableDataLoading={isTableDataLoading}
        totalData={totalData}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
        activePages={activePages}
      ></PaginationLayout>
    </StyledPaginationLayout>
  );
};

const StyledPaginationLayout = styled.span`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1.25rem;
`;

const PaginationText = styled.p`
  margin-right: 1.25rem;
  font-weight: 400;
  font-size: 12px;
  color: ${Colors.midnightExpress};
  font-family: "Poppins-Book";
  font-style: normal;
`;
